import React from "react";
import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";

const Cancellation = () => {
  const policies = [
    {
      title: "Cancelamento com 30+ dias",
      body: "Avise com 30 dias de antecedência e qualquer valor pago será devolvido integralmente.",
    },
    {
      title: "Cancelamento abaixo de 30 dias",
      body: "O valor da entrada vira CRÉDITO válido por 12 meses para nova data, sem estorno em dinheiro.",
    },
    {
      title: "Não comparecimento ao embarque",
      body: "Sem aviso prévio, qualquer valor pago é retido como multa por no-show.",
    },
    {
      title: "Imprevistos climáticos",
      body: "Em caso de impossibilidade de embarque por segurança, tentamos remarcar para o dia seguinte. Caso contrário, escolha entre devolução total ou remarcação em até 12 meses sem custo.",
    },
  ];

  return (
    <section className="relative py-24 md:py-32" data-testid="cancellation-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-start gap-4 mb-12 max-w-3xl">
          <AlertTriangle size={28} style={{ color: "var(--ocean-accent)", flexShrink: 0, marginTop: 6 }} />
          <div>
            <div className="overline mb-2">Política de cancelamento</div>
            <h2 className="font-display text-4xl md:text-5xl font-light leading-tight">
              Regras claras para você embarcar tranquilo.
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {policies.map((p, idx) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.08 }}
              className="glass p-7"
            >
              <div className="font-display text-xl mb-3" style={{ color: "var(--ocean-accent)" }}>
                {p.title}
              </div>
              <p className="text-sm leading-relaxed" style={{ color: "var(--ocean-muted)" }}>
                {p.body}
              </p>
            </motion.div>
          ))}
        </div>

        <p className="mt-10 text-xs italic max-w-3xl" style={{ color: "var(--ocean-muted)" }}>
          Cancelamentos não são habituais, mas podem ocorrer. Nosso living aboard depende essencialmente do mar.
          Contamos com sua compreensão e colaboração nesse processo.
        </p>
      </div>
    </section>
  );
};

export default Cancellation;
